import {useEffect} from 'react'
import useAtmosphere from '../hooks/useAtmosphere'
import useRouter from '../hooks/useRouter'
import AcceptTeamInvitationMutation from '../mutations/AcceptTeamInvitationMutation'





const TeamInvitationAccept = (props) => {
  const {invitationToken} = props
  const {history} = useRouter()
  const atmosphere = useAtmosphere()
  useEffect(() => {
    AcceptTeamInvitationMutation(atmosphere, {invitationToken}, {history})
  })
  return null
}

export default TeamInvitationAccept
